import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { injectIntl } from 'react-intl';

import FormLangInput from 'components/forms/FormLangInput';

class ModelGroupData extends React.Component {
  constructor(props) {
    super(props);
  }

  changeEntity = (propertyName, value) => {
    let { entity, changeEntity } = this.props;

    let newEntity = { ...entity.updateValue(propertyName, value) };

    changeEntity(newEntity);
  };

  render() {
    const { intl, entityLoaded, entity, disabled, inModal } = this.props;
    const messages = intl.messages;

    return (
      <div class="clearfix">
        {entityLoaded ? (
          <Row>
            <Col xs={12} md={inModal ? 12 : 6}>
              <div class="panel panel-transparent">
                <div class="panel-body">
                  <p className="form-group-title">{messages.formGroup.basic_information}</p>
                  <div class="form-group-attached">
                    <FormLangInput
                      label={messages.name}
                      name="name"
                      value={entity.getName()}
                      meta={entity.getNameMetaInformation()}
                      validation={entity.getNameValidationResult()}
                      onChange={this.changeEntity}
                      disabled={disabled}
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        ) : null}
      </div>
    );
  }
}
ModelGroupData.defaultProps = {
  inModal: false,
};

export default injectIntl(ModelGroupData);
